import { NavLink, Outlet } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import { Users, CreditCard, Layers, Wallet, ShieldCheck, Activity, Gift, Trophy, Tag, Handshake, FileCheck, Award, PackageOpen, Image as ImageIcon } from 'lucide-react';

const items = [
  { to: '/admin', end: true, label: 'Overview', icon: Activity, testId: 'admin-side-overview' },
  { to: '/admin/users', label: 'Users', icon: Users, testId: 'admin-side-users' },
  { to: '/admin/accounts', label: 'Accounts', icon: Layers, testId: 'admin-side-accounts' },
  { to: '/admin/inventory', label: 'Inventory', icon: PackageOpen, testId: 'admin-side-inventory' },
  { to: '/admin/orders', label: 'Orders', icon: CreditCard, testId: 'admin-side-orders' },
  { to: '/admin/phase2-requests', label: 'Phase 2 requests', icon: ShieldCheck, testId: 'admin-side-phase2' },
  { to: '/admin/funded-requests', label: 'Funded requests', icon: Trophy, testId: 'admin-side-funded' },
  { to: '/admin/payouts', label: 'Reward requests', icon: Wallet, testId: 'admin-side-payouts' },
  { to: '/admin/affiliate-payouts', label: 'Affiliate rewards', icon: Gift, testId: 'admin-side-affpay' },
  { to: '/admin/certificates', label: 'Certificates', icon: Award, testId: 'admin-side-certificates' },
  { to: '/admin/image-generator', label: 'Image Generator', icon: ImageIcon, testId: 'admin-side-imagegen' },
  { to: '/admin/promotions', label: 'Promotions', icon: Tag, testId: 'admin-side-promotions' },
  { to: '/admin/payment-agents', label: 'Payment Agents', icon: Handshake, testId: 'admin-side-pa' },
  { to: '/admin/payment-agent-applications', label: 'Agent applications', icon: FileCheck, testId: 'admin-side-papp' },
];

export default function AdminShell() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 py-8 grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-8">
        <aside className="lg:sticky lg:top-24 h-fit">
          <div className="card-tech rounded-lg p-4">
            <div className="label-sm mb-3">Admin</div>
            <div className="space-y-1">
              {items.map(it => (
                <NavLink key={it.to} to={it.to} end={it.end}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition
                     ${isActive ? 'bg-[#00ff66]/10 text-white border border-[#00ff66]/30' : 'text-zinc-400 hover:text-white hover:bg-white/5 border border-transparent'}`
                  }
                  data-testid={it.testId}
                >
                  <it.icon size={15} /> {it.label}
                </NavLink>
              ))}
            </div>
          </div>
        </aside>
        <main><Outlet /></main>
      </div>
    </div>
  );
}
